import React from 'react';

type Level = {
  id: string;
  title: string;
  color: string;
  points: number;
  image: string;
  inactiveImage: string;
  active: boolean;
};

type Props = {
  currentLevelName: string;
  levels: Level[];
};

const LevelProgress: React.FC<Props> = ({ currentLevelName, levels }) => {
  const currentIndex = levels.findIndex(l => l.title === currentLevelName);

  return (
    <div className="p-6 grid grid-cols-1 sm:grid-cols-2 gap-4 border-t border-gray-200 mt-5">
      {levels.map((level, index) => {
        const isActive = index <= currentIndex;

        return (
          <div
            key={level.id}
            className="flex items-center space-x-4"
          >
            <img
              src={isActive ? level.image : level.inactiveImage}
              alt={level.title}
              className="w-23 h-23"
            />
            <div>
              <h3 className="text-lg font-medium font-juana">{`${index + 1}. ${level.title}`}</h3>
              <p className="text-sm text-gray-600">
                {index === 0
                  ? `Hasta los ${(levels[1].points - 1).toLocaleString()} pts`
                  : `Desde los ${level.points.toLocaleString()} pts`}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default LevelProgress;
